var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveViewmodeSplit40(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4C12.95,4,4,12.95,4,24s8.95,20,20,20,20-8.95,20-20S35.05,4,24,4ZM24,42c-9.93,0-18-8.07-18-18S14.07,6,24,6s18,8.07,18,18-8.07,18-18,18Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87,22.66l.6.66h3.04l.59-.62c1.86-1.96,3.25-3.77,4.42-6.74.67-1.68.45-3.65-.56-5.14-.68-1.01-2.37-2.7-5.95-2.7s-5.25,1.68-5.94,2.68c-1.02,1.49-1.24,3.46-.58,5.15,1.04,2.68,2.51,4.63,4.39,6.72ZM25.94,16.92h-.94v-6.74c.34.04.65.1.94.18v6.55ZM23,16.92h-.95v-6.55c.29-.08.61-.14.95-.19v6.74ZM24.64,21.33h-1.29c-.73-.81-1.39-1.59-1.97-2.4h5.28c-.59.82-1.25,1.58-2.02,2.4ZM28.65,15.22c-.23.58-.47,1.1-.72,1.59v-5.31c1.03,1.09,1.16,2.6.72,3.72ZM20.05,11.51v5.27c-.26-.49-.49-1.01-.71-1.56-.44-1.12-.31-2.62.71-3.71Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.76,36.13h22.49v-10.84H12.76v10.84ZM25.06,34.13h-2.11v-6.84h2.11v6.84ZM27.06,27.3h2.11v6.84h-2.11v-6.84ZM20.94,34.13h-2.11v-6.84h2.11v6.84ZM33.24,34.13h-2.08v-6.84h2.08v6.84ZM14.76,27.3h2.08v6.84h-2.08v-6.84Z",
    fill: "#030303",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveViewmodeSplit40);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-viewmode-split-40.8cc246e123afd8358a458e65239e245f.svg";
export { ForwardRef as ReactComponent };